'use strict';

// import $ from 'jquery';

// ===================================
// Custom plugins
// ===================================

/**
 * @param {JQuery.TriggeredEvent} e
 */
const mouseZoomImage = (e) => {
	/** @type {HTMLElement} */
	// @ts-ignore
	const zoomTarget = e.currentTarget;
	const offsetX = e.offsetX ?? e.touches[0].pageX;
	const offsetY = e.offsetY ?? e.touches[0].pageX;
	const x = offsetX / zoomTarget.offsetWidth * 100;
	const y = offsetY / zoomTarget.offsetHeight * 100;
	zoomTarget.style.backgroundPosition = x + '% ' + y + '%';
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	if (mpro.isMobileScreen() === false) {
		const $zoomElements = $container.find('figure[data-zoom-image]');
		if ($zoomElements.length > 0) {
			$zoomElements.each((_, element) => {
				const $element = $(element);
				$element.css('backgroundImage', `url("${element.dataset.zoomImage}")`);
				$element.on('mousemove touchmove', mouseZoomImage);
			});
		}
	}
});

export default mpro;
